import { callFirebaseFunction } from 'boot/firebase';
import AppointmentsDB from 'src/fb/appointments-db';
import { batchUpdateDocuments } from 'src/utils/AppUtils';

const batchUpdateAppointments = async (appointmentsToUpdate, updateData) => {
  await batchUpdateDocuments(appointmentsToUpdate, updateData, 'appointments');
};

const appointmentReferenceField = {
  USER: 'integrationStaffParRef',
  CLIENT: 'integrationClientParRef',
};

/**
 * @param {string} clinic
 * @param {string} refId
 * @param {'integrationClientParRef' | 'integrationStaffParRef'} field
 * @return {Promise<object[] | []>} - array of appointments from Db
 */
const findAppointmentsByRef = async (clinic, refId, field) => {
  if (!['integrationClientParRef', 'integrationStaffParRef'].includes(field)) {
    throw new Error('findAppointmentsByRef(): unknown ref field');
  }

  const appointmentsDb = new AppointmentsDB();

  return appointmentsDb.readAll([
    ['clinic', '==', clinic],
    ['status', '!=', 'completed'],
    [field, '==', refId],
  ]);
};

/**
 * @param {string} clinic
 * @param {string} refId
 * @param {Object} changeData - data to update
 * @param {string|null} changeData.userId
 * @param {string|null} changeData.userName
 * @return {Promise<void | string[]>}
 */
export const updateAppointmentUserReference = async (clinic, refId, { userId = null, userName = null }) => {
  const appointmentsToUpdate = await findAppointmentsByRef(clinic, refId, appointmentReferenceField.USER);

  if (!appointmentsToUpdate.length) {
    return;
  }

  return batchUpdateAppointments(appointmentsToUpdate, {
    user: userId,
    userName,
  });
};

/**
 * @param {string} clinic
 * @param {string|null} clientId
 * @param {string} refId
 * @return {Promise<void | string[]>}
 */
export const updateAppointmentClientReference = async (clinic, clientId, refId) => {
  const appointmentsToUpdate = await findAppointmentsByRef(clinic, refId, appointmentReferenceField.CLIENT);

  if (!appointmentsToUpdate.length) {
    return;
  }

  return batchUpdateAppointments(appointmentsToUpdate, {
    client: clientId,
  });
};

/**
 * Sends an event to Aloha integration.
 * @param {string} clinic
 * @param {string} eventType
 * @param {Object?} data
 * @returns {Promise<HttpsCallableResult<unknown>>}
 */
export const sendEventToAloha = async (clinic, eventType, data = null) => {
  return callFirebaseFunction('sendEventToAloha', {
    clinic,
    eventType,
    data,
  });
};
